<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-news_category p-col-fixed txt-right txt-required">Name</label>
          <div class="p-col">
            <InputText id="name" class="p-inputtext p-col-width pac-target-input"
              placeholder="Input (max 255 charactors)" v-model="obj_data.name" @input="handleMaxCharacter($event, 255)" />
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-card-field mt-1">
          <label class="indam-news_category p-col-fixed txt-right">Order</label>
          <div class="p-col">
            <InputNumber id="ordinal" v-model="obj_data.ordinal" :min="0" placeholder="0" />
          </div>
        </div>
      </div>
      <!-- <div class="col-6">
        <div class="p-card-field mt-1">
          <label class="p-col-fixed txt-right txt_style_lable">Type</label>
          <div class="p-col">
            <div class="type-options">
              <label>
                <input type="radio" name="type_category" value="0" v-model="obj_data.type_category">News
              </label>
              <label>
                <input type="radio" name="type_category" value="1" v-model="obj_data.type_category">Promotions
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
      <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
        Are you sure you want to delete?
        <template #footer>
          <Button label="Delete" @click="deleteData()" icon="pi pi-check"
            class="p-button-danger  btn-confirm-delete-dialog" />
          <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        </template>
      </Dialog>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      key_type_id: 1,
      deleteId: null,
      showDeleteDialog: false,
      listDataType: [],
      obj_data: {},
      comFilename: 1,
      componentKey: 0,
      list_file: [],
      list_file_edit: [],
      list_id_file_delete: [],
      maxFileSize: 2097152 * 50,
    };
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      this.componentKey++;
    } else {
      this.obj_data = {
        active: true,
        type_category: 0,
      };
      this.componentKey++;
    }
  },
  methods: {
    handleMaxCharacter(event, maxLength = 255) {
      let value = event
      if (value.length > maxLength) {
        value = value.slice(0, maxLength)
      }
      this.obj_data.name = value;
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = [];
      for (let i = 0; i < this.listDataType.length; i++) {
        var item_data = this.listDataType[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataType = list_data;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${year}`;
    },

    isImage(file) {
      return /^image\//.test(file.type);
    },

    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [{ id: 'name', value: this.obj_data.name }];
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (
          inputElement &&
          (inputElement.tagName === 'INPUT' ||
            inputElement.tagName === 'TEXTAREA' ||
            inputElement.tagName === 'SELECT')
        ) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(
              this.$constants.MSG_TEXT.INPUT_INVALID_MSG
            );
            isFormInvalid = true;
          } else if (field.id === "name" && field.value.length > 255) {
            inputElement.setCustomValidity("Name must not exceed 255 characters.");
            isFormInvalid = true;
          } else if (
            field.minValue !== undefined &&
            field.value <= field.minValue
          ) {
            inputElement.setCustomValidity(
              this.$constants.MSG_TEXT.INPUT_INVALID_MSG
            );
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity('');
          }
        }
      }
      let inpObj = document.getElementById('frm_action');
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var params = { ...this.obj_data };
      this.$emit('save', params);
    },
  },
};
</script>
<style lang="scss">
.p-formgrid {
  padding-top: 20px;
}

.p-formgrid .fixed-bottom-toolbar .p-button#back .p-button-label {
  color: #000000 !important;
  font-weight: 500;
}

.p-formgrid .fixed-bottom-toolbar .main-style-button {
  background-color: #ffdf01 !important;
  font-weight: 500;
}

.main-style-button {
  background-color: #0086c4 !important;
}

.opacity-text-file {
  opacity: 0.5;
}

.calendar-css-margin1 {
  padding-right: 0px !important;
}

.calendar-css-margin2 {
  padding-left: 0px !important;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.category-item-value {
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: 0.2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 2px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}

.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #c8c8c8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #c8c8c8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}

.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #d0d4d9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}

.indam-news_category {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}

.type-options {
  display: flex; // Sử dụng flexbox để căn chỉnh ngang
  gap: 30px; // Khoảng cách giữa các radio button

  label {
    display: flex;
    align-items: center; // Căn giữa theo chiều dọc
    cursor: pointer; // Hiển thị con trỏ khi hover

    input[type="radio"] {
      width: 20px; // Chiều rộng
      height: 20px; // Chiều cao
      margin-right: 5px; // Khoảng cách giữa radio button và nhãn
    }
  }
}
</style>
